// Arrows show only at an end with more chips past it
function updateArrows(scroller, chips){
    const maxScroll = chips.scrollWidth - chips.clientWidth;
    scroller.querySelector('[data-chip-scroll="-1"]').hidden = chips.scrollLeft <= 1;
    scroller.querySelector('[data-chip-scroll="1"]').hidden = chips.scrollLeft >= maxScroll - 1;
}

export function initChipScroller(scroller){
    if (!scroller){
        return;
    }
    const chips = scroller.querySelector('[data-chip-scroll-track]');
    const update = () => updateArrows(scroller, chips);

    scroller.addEventListener('click', (event) => {
        const arrow = event.target.closest('[data-chip-scroll]');
        if (arrow){
            chips.scrollBy({ left: Number(arrow.dataset.chipScroll) * chips.clientWidth * 0.7, behavior: 'smooth' });
        }
    });

    // A mouse wheel only scrolls vertically, so turn it sideways while over the chips
    chips.addEventListener('wheel', (event) => {
        const maxScroll = chips.scrollWidth - chips.clientWidth;
        if (maxScroll <= 0 || Math.abs(event.deltaX) > Math.abs(event.deltaY)){
            return;
        }
        // At either end, let the page scroll as usual
        if ((event.deltaY < 0 && chips.scrollLeft <= 0) || (event.deltaY > 0 && chips.scrollLeft >= maxScroll - 1)){
            return;
        }
        event.preventDefault();
        chips.scrollLeft += event.deltaY;
    }, { passive: false });

    chips.addEventListener('scroll', update, { passive: true });
    if (typeof ResizeObserver !== 'undefined'){
        new ResizeObserver(update).observe(chips);
    }
    // Jump links are added after load and hidden by filters, which changes the overflow without resizing the track
    if (typeof MutationObserver !== 'undefined'){
        new MutationObserver(update).observe(chips, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    update();
}
